<script setup>
import { StatusEnum } from "@/utilities/enum";
import { download } from "@/utilities/globalFunction";
</script>

<template>
  <div class="flex items-center justify-between">
    <h3 class="font-medium text-lg text-gray-800">Konsumsi Elektrifikasi</h3>
  </div>

  <hr class="border-t-2 border-dashed border-gray-500" />

  <div class="grid grid-cols-2 gap-3 items-center">
    <v-text-field
      variant="outlined"
      color="#475569"
      density="compact"
      hide-details
      clearable
      prepend-inner-icon="mdi-magnify"
      placeholder="Cari jenis elektrifikasi"
      v-model="keyword"
      @keyup.enter="searchData"
    ></v-text-field>
    <div class="flex justify-end">
      <v-btn
        class="capitalize text-xs min-w-40 w-40 bg-gray-800"
        @click="addRow()"
        v-if="
          (!status ||
            status === StatusEnum.DRAFT ||
            status === StatusEnum.REVISION ||
            (status === StatusEnum.COMPLETED && isAdmin)) &&
          !isPjo
        "
      >
        <span class="text-white text-sm">Tambah List</span>
        <template v-slot:prepend>
          <img
            src="../../../assets/icon/add-square.png"
            alt="icon"
            class="w-5 h-auto"
            loading="lazy"
          />
        </template>
      </v-btn>
    </div>
  </div>
  <div class="w-full">
    <v-data-table-server
      :items-per-page="existing.perPage"
      :headers="
        localDataTable.headers.filter((item, index, array) => {
          if (
            (status === StatusEnum.COMPLETED && !isAdmin) ||
            status === StatusEnum.WAITING_APPROVAL
          ) {
            if (index === array.length - 1) {
              return item.title !== '';
            }
          }

          const isFile = localDataTable.items.some(
            (item) => item.electric?.is_file
          );
          const isUnit = localDataTable.items.some(
            (item) => item.electric?.is_unit
          );

          if (!isFile && item.title === 'File') {
            return false;
          }
          if (!isUnit && item.title === 'Jumlah Unit') {
            return false;
          }

          if (isFile && isUnit && item.title === 'Jenis Elektrifikasi') {
            item.width = '30%';
          }
          if (isFile && isUnit && item.title === 'Total Elektrifikasi (MWh)') {
            item.width = '20%';
          }
          if (isFile && isUnit && item.title === 'File') {
            item.width = '20%';
          }
          if (isFile && isUnit && item.title === 'Jumlah Unit') {
            item.width = '20%';
          }

          if (isFile && !isUnit && item.title === 'Jenis Elektrifikasi') {
            item.width = '30%';
          }
          if (isFile && !isUnit && item.title === 'Total Elektrifikasi (MWh)') {
            item.width = '30%';
          }

          if (!isFile && isUnit && item.title === 'Jenis Elektrifikasi') {
            item.width = '30%';
          }
          if (!isFile && isUnit && item.title === 'Total Elektrifikasi (MWh)') {
            item.width = '30%';
          }
          return true;
        })
      "
      :items="localDataTable.items"
      :loading="existing.loading"
      :items-length="existing.totalItems"
      :page="existing.page"
      @update:options="fetchData"
    >
      <template #thead>
        <thead class="summary">
          <tr class="h-14 border-y">
            <td></td>
            <td>
              <div
                class="w-full h-10 rounded-md bg-blue-100 flex justify-center items-center"
              >
                <h5 class="font-medium text-black text-sm">
                  {{ countElectric() }}
                </h5>
              </div>
            </td>
            <td
              v-if="localDataTable.items.some((row) => row.electric?.is_unit)"
            >
              <div
                class="w-full h-10 rounded-md bg-blue-100 flex justify-center items-center"
              >
                <h5 class="font-medium text-black text-sm">
                  {{ sumUnit() }}
                </h5>
              </div>
            </td>
            <td
              v-if="localDataTable.items.some((row) => row.electric?.is_file)"
            >
              <div
                class="w-full h-10 rounded-md bg-blue-100 flex justify-center items-center"
              >
                <h5 class="font-medium text-black text-sm">
                  {{ countFile() }}
                </h5>
              </div>
            </td>
            <td>
              <div
                class="w-full h-10 rounded-md bg-blue-100 flex justify-center items-center"
              >
                <h5 class="font-medium text-black text-sm">
                  {{ sumTotal() }}
                </h5>
              </div>
            </td>
            <td
              v-if="
                (!status ||
                  status === StatusEnum.DRAFT ||
                  status === StatusEnum.REVISION) &&
                !isPjo
              "
            ></td>
          </tr>
        </thead>
      </template>
      <template v-slot:item="{ item, index }">
        <tr class="border-gray-950 h-14 align-top" v-if="!item.deleted">
          <td class="pt-4 font-medium">
            <p>{{ getIndex(index)?.displayIndex }}</p>
          </td>
          <td class="py-2">
            <v-tooltip
              :text="item.electric?.name ?? null"
              location="top"
              :disabled="
                !item.electric?.name || item.electric?.name?.trim() === ''
              "
              v-if="
                (!status ||
                  status === StatusEnum.DRAFT ||
                  status === StatusEnum.REVISION ||
                  (status === StatusEnum.COMPLETED && isAdmin)) &&
                !isPjo
              "
            >
              <template v-slot:activator="{ props }">
                <v-autocomplete
                  :key="item.uuid"
                  v-bind="item.electric?.name ? props : {}"
                  class="w-full"
                  variant="outlined"
                  color="#475569"
                  rounded="xs"
                  density="compact"
                  placeholder="Pilih jenis"
                  :items="
                    listElektric.find((data) => data?.uuid === item?.uuid)
                      ?.value
                  "
                  item-title="title"
                  item-value="value"
                  v-model="item.electric"
                  @input="
                    (event) => {
                      getElectric(event.target.value, item.uuid),
                        (item.electric = null);
                    }
                  "
                  :rules="formValidasi.electric"
                  :id="'electric_' + getIndex(index).displayIndex"
                  autocomplete="off"
                  :error-messages="
                    existing.items.find((data) => data.uuid === item.uuid)
                      ?.duplicate
                      ? 'Pilih elektrifikasi yang berbeda.'
                      : getErrors(item, 'electric')
                  "
                  hide-details="auto"
                  :error="hasErrors(item, 'electric')"
                  @blur="item.electric_touched = true"
                  @update:model-value="item.changed = true"
                >
                </v-autocomplete>
              </template>
            </v-tooltip>

            <h6 v-else class="font-normal text-sm mt-2">
              {{ item.name }}
            </h6>
          </td>
          <td
            class="py-2"
            v-if="localDataTable.items.some((row) => row.electric?.is_unit)"
          >
            <template v-if="item.electric?.is_unit">
              <div
                v-if="
                  (!status ||
                    status === StatusEnum.DRAFT ||
                    status === StatusEnum.REVISION ||
                    (status === StatusEnum.COMPLETED && isAdmin)) &&
                  !isPjo
                "
              >
                <v-text-field
                  :key="item.uuid"
                  variant="outlined"
                  color="#475569"
                  density="compact"
                  placeholder="ex: 100"
                  class="w-full"
                  @input="handleInput($event, 'unit_electric', index)"
                  v-model="item.unit"
                  :id="'unit_' + getIndex(index)?.displayIndex"
                  :rules="formValidasi.unit"
                  autocomplete="off"
                  hide-details="auto"
                  @blur="item.unit_touched = true"
                  @update:model-value="item.changed = true"
                  :error="hasErrors(item, 'unit')"
                  :error-messages="getErrors(item, 'unit')"
                ></v-text-field>
              </div>
              <div v-else>
                <h6 class="font-normal text-sm mt-2">
                  {{ item.unit }}
                </h6>
              </div>
              <v-tooltip
                :text="item.electric.description_unit"
                location="top"
                class="text-xs"
                style="
                  white-space: pre-line;
                  word-break: break-word;
                  overflow-wrap: break-word;
                "
              >
                <template v-slot:activator="{ props }">
                  <div class="py-2 w-fit" v-bind="props">
                    <i
                      class="mdi mdi-alert-circle-outline bg-slate-200 px-[2px] py-[1px] rounded-full"
                    ></i>
                  </div>
                </template>
              </v-tooltip>
            </template>
          </td>
          <td
            class="pt-2"
            v-if="localDataTable.items.some((row) => row.electric?.is_file)"
          >
            <template v-if="item.electric?.is_file">
              <div
                v-if="
                  (!status ||
                    status === StatusEnum.DRAFT ||
                    status === StatusEnum.REVISION ||
                    (status === StatusEnum.COMPLETED && isAdmin)) &&
                  !isPjo
                "
              >
                <v-file-input
                  prepend-icon=""
                  prepend-inner-icon="mdi-upload"
                  accept=".pdf"
                  :key="item.uuid"
                  variant="outlined"
                  color="#475569"
                  v-model="item.file"
                  density="compact"
                  placeholder="Pilih file"
                  :id="'file_' + getIndex(index)?.displayIndex"
                  :rules="
                    item.file
                      ? formValidasi.file
                      : item.url_file
                      ? []
                      : formValidasi.file
                  "
                  hide-details="auto"
                  @blur="item.file_touched = true"
                  @update:model-value="item.changed = true"
                  :error="hasErrors(item, 'file')"
                  :error-messages="getErrors(item, 'file')"
                ></v-file-input>
                <h5
                  class="text-xs font-medium text-blue-500 cursor-pointer underline mt-1"
                  v-if="item.url_file"
                  @click="download(item.url_file)"
                >
                  File saat ini
                </h5>
              </div>
              <div v-else class="mt-2">
                <div class="flex justify-center items-center">
                  <img
                    src="../../../assets/icon/download-file.png"
                    alt="img download"
                    class="w-5 h-fit cursor-pointer"
                    v-if="item.url_file"
                    @click="download(item.url_file)"
                  />
                  <span class="font-medium text-center" v-else> N/A </span>
                </div>
              </div>
              <v-tooltip
                :text="item.electric.description_file"
                location="top"
                class="text-xs"
                style="
                  white-space: pre-line;
                  word-break: break-word;
                  overflow-wrap: break-word;
                "
              >
                <template v-slot:activator="{ props }">
                  <div class="py-2 w-fit" v-bind="props">
                    <i
                      class="mdi mdi-alert-circle-outline bg-slate-200 px-[2px] py-[1px] rounded-full"
                    ></i>
                  </div>
                </template>
              </v-tooltip>
            </template>
          </td>
          <td class="py-2">
            <v-text-field
              :key="item.uuid"
              variant="outlined"
              color="#475569"
              density="compact"
              placeholder="ex: 100"
              class="w-full"
              @input="handleInput($event, 'total_electric', index)"
              v-model="item.total"
              :id="'total_' + getIndex(index)?.displayIndex"
              :rules="formValidasi.total"
              autocomplete="off"
              hide-details="auto"
              @blur="item.total_touched = true"
              @update:model-value="item.changed = true"
              :error="hasErrors(item, 'total')"
              :error-messages="getErrors(item, 'total')"
              v-if="
                (!status ||
                  status === StatusEnum.DRAFT ||
                  status === StatusEnum.REVISION ||
                  (status === StatusEnum.COMPLETED && isAdmin)) &&
                !isPjo
              "
            ></v-text-field>
            <h6 v-else class="font-normal text-sm mt-2">
              {{ item.total }}
            </h6>
          </td>
          <td
            class="text-center pt-4"
            v-if="
              (!status ||
                status === StatusEnum.DRAFT ||
                status === StatusEnum.REVISION ||
                (status === StatusEnum.COMPLETED && isAdmin)) &&
              !isPjo
            "
          >
            <img
              src="../../../assets/icon/trash.png"
              alt="icon"
              loading="lazy"
              class="min-w-6 w-6 cursor-pointer h-auto"
              @click="removeRow(item.existing_index)"
              :id="'remove_' + getIndex(index)?.displayIndex"
            />
          </td>
        </tr>
      </template>
    </v-data-table-server>
  </div>
</template>

<script>
import {
  formatNumberToString,
  formatStringToNumber,
} from "@/utilities/helpers";

export default {
  name: "ContentElektrificationComponent",
  data() {
    return {
      keyword: null,
    };
  },
  props: {
    dataTable: Object,
    existing: Object,
    formValidasi: Object,
    loading: Boolean,
    listElektric: Array,
    getElectric: Function,
    handleInput: Function,
    addRow: Function,
    removeRow: Function,
    isPjo: Boolean,
    status: String,
    isAdmin: Boolean,
  },
  computed: {
    localDataTable: {
      get() {
        return this.dataTable;
      },
      set(newValue) {
        this.$emit("update:dataTable", newValue); // Kirim event ke parent
      },
    },
    indexedData() {
      let counter = 1;
      let startIndex = this.dataTable.start_index ?? 0;
      return this.dataTable.items.map((dt, index) => {
        if (!dt.deleted) {
          return {
            ...dt,
            displayIndex: startIndex + counter++,
            realIndex: index,
          };
        } else {
          return { ...dt, displayIndex: null, realIndex: index };
        }
      });
    },
  },
  methods: {
    download,
    async fetchData({ page, itemsPerPage } = {}) {
      this.$emit("fetch-data", page, itemsPerPage);
    },
    async searchData() {
      this.$emit("search-data", this.keyword);
    },
    getIndex(index) {
      return this.indexedData.find((item) => item.realIndex === index);
    },
    countElectric() {
      return this.dataTable.items.filter((item) => item.electric).length;
    },
    sumUnit() {
      let total = 0;
      total = this.existing.items
        .filter((item) => !item.deleted && item.unit)
        .map((data) => {
          const num = formatStringToNumber(data.unit);
          return isNaN(num) ? 0 : num;
        })
        .reduce((sum, num) => sum + num, 0);
      return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    countFile() {
      return this.existing.items.filter((item) => !item.deleted && item.file)
        .length;
    },
    sumTotal() {
      const total = this.dataTable.items
        .filter((item) => item.total)
        .map((data) => {
          const num = formatStringToNumber(data.total);
          return isNaN(num) ? 0 : num;
        })
        .reduce((sum, num) => sum + num, 0);

      return formatNumberToString(total);
    },
    hasErrors(data, touched) {
      return this.getErrors(data, touched).length > 0;
    },
    getErrors(value, touched) {
      if (!value[`${touched}_touched`]) return [];
      const rules = this.formValidasi[touched];
      const errors = rules
        .map((rule) => rule(value[touched]))
        .filter((result) => result !== true);
      return errors;
    },
  },
  emits: ["fetch-data", "search-data"],
};
</script>

<style scoped>
:deep(.v-table > .v-table__wrapper > table > tbody > tr > td),
:deep(.v-table > .v-table__wrapper > table > thead > tr > td),
:deep(.v-table > .v-table__wrapper > table > thead > tr > th) {
  padding: 0px 5px;
}
</style>
